export default function activeBreakpoint() {
  return window
    .getComputedStyle(document.querySelector('body'), '::before')
    .getPropertyValue('content')
    .replace(/"/g, '')
}
